(function () {

  function blockEnterOnCheckout() {
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Enter') {
          const isInsideCheckout = event.target.closest(
            'form.checkout, form.woocommerce-checkout, form#order_review'
          );

          if (isInsideCheckout) {
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', blockEnterOnCheckout);
  } else {
    blockEnterOnCheckout();
  }

})();